var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewExclamation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "m8.362 0 .79 1.719 1.773-.657.072 1.89 1.89.072-.657 1.774 1.719.79-1.286 1.386 1.286 1.388-1.719.79.657 1.773-1.89.072-.072 1.89-1.774-.657-.79 1.719-1.387-1.286-1.387 1.286-.79-1.719-1.773.657-.072-1.89-1.89-.072.657-1.774L0 8.361l1.286-1.387L0 5.587l1.719-.79-.657-1.773 1.89-.072.072-1.89 1.774.657L5.588 0l1.386 1.286L8.362 0zM6.974 8.752a.889.889 0 1 0 0 1.778.889.889 0 0 0 0-1.778zm0-5.333a.889.889 0 0 0-.888.889v2.666a.889.889 0 0 0 1.777 0V4.308a.889.889 0 0 0-.889-.89z",
    id: "a"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.026 1.026)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#63686B",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)",
    fill: "#3057B9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1.026-1.026h16v16h-16z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewExclamation);
export default __webpack_public_path__ + "static/media/new-exclamation.42c8125edfb68ed3fc3c4e59c52a4648.svg";
export { ForwardRef as ReactComponent };